<template>
  <div class="cms-page-header">
    <div class="cms-page-header-left">
      <h2 class="cms-page-title">{{ title }}</h2>
      <p v-if="subtitle" class="cms-page-subtitle">{{ subtitle }}</p>
    </div>
    
    <div class="cms-page-header-actions">
      <slot name="actions">
        <cms-button
          v-if="showCreate"
          variant="primary"
          :icon="createIcon"
          @click="$emit('create')"
        >
          {{ createText }}
        </cms-button>
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import CmsButton from './CmsButton.vue';

interface Props {
  title: string;
  subtitle?: string;
  createText?: string;
  createIcon?: string;
  showCreate?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showCreate: true,
  createIcon: 'plus'
});

const { t } = useI18n();
const createText = props.createText || t('general.create');

defineEmits<{
  (e: 'create'): void;
}>();
</script>

<style lang="scss" scoped>
@import './cms-styles.scss';

.cms-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: $cms-spacing-xl;
  margin-top: $cms-spacing-md;
  gap: $cms-spacing-md;
  flex-wrap: wrap;
}

.cms-page-header-left {
  display: flex;
  flex-direction: column;
  gap: $cms-spacing-xs;
}

.cms-page-title {
  font-size: $cms-font-size-xl;
  font-weight: 600;
  margin: 0;
  color: $cms-text-primary;
}

.cms-page-subtitle {
  font-size: $cms-font-size-base;
  color: $cms-text-secondary;
  margin: 0;
}

.cms-page-header-actions {
  display: flex;
  gap: $cms-spacing-md;
  align-items: center;
}

@include cms-responsive-mobile {
  .cms-page-header {
    flex-direction: column;
    align-items: stretch;
  }
  
  .cms-page-header-actions {
    width: 100%;
    
    :deep(.cms-btn) {
      width: 100%;
      justify-content: center;
    }
  }
}
</style>

